// reCAPTCHA v3 helper.
// Loads the Google script on first use and returns a per-action token.
const SITE_KEY = process.env.REACT_APP_RECAPTCHA_SITE_KEY;
let scriptPromise = null;

function loadScript() {
  if (!SITE_KEY) return Promise.reject(new Error("no site key"));
  if (typeof window === "undefined") return Promise.reject(new Error("no window"));
  if (window.grecaptcha && window.grecaptcha.execute) return Promise.resolve();
  if (scriptPromise) return scriptPromise;

  scriptPromise = new Promise((resolve, reject) => {
    const existing = document.querySelector('script[data-recaptcha]');
    if (existing) {
      existing.addEventListener("load", resolve);
      return;
    }
    const s = document.createElement("script");
    s.src = `https://www.google.com/recaptcha/api.js?render=${SITE_KEY}`;
    s.async = true;
    s.defer = true;
    s.dataset.recaptcha = "true";
    s.onload = () => window.grecaptcha.ready(resolve);
    s.onerror = () => reject(new Error("recaptcha script failed"));
    document.head.appendChild(s);
  });
  return scriptPromise;
}

export async function getRecaptchaToken(action) {
  if (!SITE_KEY) return null;
  try {
    await loadScript();
    return await window.grecaptcha.execute(SITE_KEY, { action });
  } catch {
    return null;
  }
}

export const recaptchaEnabled = () => !!SITE_KEY;
